import { Typography } from "@mui/material";
import howItWorks from "../../assets/how-it-works.svg";

export default function HowItWorks() {
    return (
        <div id="how_it_works" className="HowItWorks">
            <Typography variant="h2">
                <b>HOW</b> IT WORKS
            </Typography>
            <div className="Container">
                <img src={howItWorks} alt="how it works" />
            </div>
        </div>
    );
}
